import { customPaymentMethods } from "@jti/fe-common";
export const selectIsPayOnDeliveryEnabled = (state) => state.cart.availablePaymentMethods.some(({ code }) => code === customPaymentMethods.payOnDelivery);
//# sourceMappingURL=selectIsPayOnDeliveryEnabled.js.map